export default __webpack_public_path__ + "static/media/ami-logo.e251c6f1.svg";